'use strict';

angular.module('study.login', [
    'route',
    'user',
]);
